if ( typeof ProductQuantity !== 'function' ) {

	// Check if this quantity selector is for a bonus item (exempt from min quantity)
	function isBonusItem(element) {
		// Check for data-bonus-item attribute on the cart item container
		const cartItem = element.closest('[data-js-cart-item]');
		if (cartItem && cartItem.hasAttribute('data-bonus-item')) {
			return true;
		}
		return false;
	}

	// Show minimum quantity message below the quantity picker
	function showMinQuantityMessage(productQuantityElement, minQty) {
		// Skip message for bonus items (they can have quantity 1)
		if (isBonusItem(productQuantityElement)) {
			return;
		}

		// Find the cart-product-quantity element (the actual picker with minus/number/plus)
		const cartProductQty = productQuantityElement.querySelector('cart-product-quantity') || productQuantityElement;
		
		// Check if message already exists
		const existingMessage = productQuantityElement.querySelector('.qty-min-message');
		if (existingMessage) {
			// Reset animation by removing and re-adding
			existingMessage.style.opacity = '0';
			setTimeout(() => {
				existingMessage.style.opacity = '1';
			}, 10);
			return;
		}
		
		// Create message element
		const message = document.createElement('div');
		message.className = 'qty-min-message';
		message.textContent = `Minimum Quantity: ${minQty}`;
		message.style.cssText = `
			text-align: center;
			color: #C41E3A;
			font-size: 12px;
			font-weight: 600;
			font-family: 'Cabrito Sans Norm', sans-serif;
			margin-top: 14px;
			opacity: 0;
			transition: opacity 0.3s ease;
			width: 100%;
		`;
		
		// Insert right after cart-product-quantity to be directly below the picker
		if (cartProductQty && cartProductQty.parentNode) {
			cartProductQty.parentNode.insertBefore(message, cartProductQty.nextSibling);
		} else {
			productQuantityElement.appendChild(message);
		}
		
		// Fade in
		setTimeout(() => {
			message.style.opacity = '1';
		}, 10);
	}

	class ProductQuantity extends HTMLElement {

		constructor(){

			super();

			const qty = this.querySelector('.qty-selector'),
						qtyMinus = this.querySelector('.qty-minus'),
						qtyPlus = this.querySelector('.qty-plus'),
						qtyMin = qty.getAttribute('min') ? parseInt(qty.getAttribute('min')) : 1,
						qtyMax = qty.getAttribute('max') ? parseInt(qty.getAttribute('max')) : 999;

			if ( parseInt(qty.value) - 1 < qtyMin ) {
				qtyMinus.classList.add('disabled');
			}
			if ( parseInt(qty.value) + 1 > qtyMax ) {
				qtyPlus.classList.add('disabled');
			}

			qty.addEventListener('change', (e)=>{
				const currentQty = parseInt(qty.value);
				if ( parseInt(qty.value) - 1 < qtyMin ) {
					qtyMinus.classList.add('disabled');
				} else {
					qtyMinus.classList.remove('disabled');
				}
				if ( parseInt(qty.value) + 1 > qtyMax ) {
					qtyPlus.classList.add('disabled');
				} else {
					qtyPlus.classList.remove('disabled');
				}
			});

			qtyMinus.addEventListener('click', (e)=>{
				e.preventDefault();
				const currentQty = parseInt(qty.value);
				
				// Show message below quantity picker if trying to go below minimum
				if ( qtyMinus.classList.contains('disabled') || currentQty <= qtyMin ) {
					showMinQuantityMessage(this, qtyMin);
					return;
				}
				
				if ( currentQty - 1 >= qtyMin ) {
					qty.value = currentQty - 1;
					qtyPlus.classList.remove('disabled');
				} 
				if ( currentQty - 1 <= qtyMin ) {
					qtyMinus.classList.add('disabled');
				}
			});

			qtyPlus.addEventListener('click', (e)=>{
				e.preventDefault();
				if ( ! qtyPlus.classList.contains('disabled') ) {
					const currentQty = parseInt(qty.value);
					if ( currentQty + 1 <= qtyMax ) {
						qty.value = currentQty + 1;
						qtyMinus.classList.remove('disabled');
					} 
					if ( currentQty + 1 >= qtyMax ) {
						qtyPlus.classList.add('disabled');
					}
				}
			});

		}
		
	}


  if ( typeof customElements.get('product-quantity') == 'undefined' ) {
    customElements.define('product-quantity', ProductQuantity);
	}

}